import * as Yup from "yup";
import { reverseShape } from "Components/shared/helpers/reverse-shape";
import { validString } from "Components/shared/helpers/validations";

export const IssueTypeFormSchema = Yup.object().shape(
    reverseShape({
        settingID: validString.optional(),
        name: validString.required(),
        remark: validString.required(),
    })
);